module.exports = __webpack_public_path__ + "img/番外_开国大典_04_宰相回宫.2704c250.png";